import { COLLAPSIBLE_LIST_TYPE } from './types.js';
import { DEFAULTS } from './defaults.js';
import { createCollapsibleListData } from './createCollapsibleListData.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { Shortcut } from 'ricos-types';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';
import { findParentNodeClosestToPos } from './tiptap/utils.js';
import 'lodash';
import 'wix-rich-content-common';
import 'ricos-content/libs/toDraftData';
import 'ricos-schema/dist/statics/collapsible_list.defaults.json';
import './tiptap/component.js';
import 'react';
import './components/NewPairButton.js';
import 'prop-types';
import './style-inject.es-746bb8ed.js';
import './data-hooks.js';
import './icons/PlusIcon.js';
import './collapsible-list-component.rtlignore-dbd7974d.js';
import './collapsible-list-pair.rtlignore-f5fa541f.js';
import './components/ExpandCollapseButton.js';
import 'classnames';
import './icons/ArrowIcon.js';
import 'ricos-context';
import './tiptap/defaults.js';
import './icons/DndIcon.js';
import './tiptap/keyboardShortcuts.js';
import './consts.js';
import '@tiptap/pm/state';
import '@tiptap/pm/view';
import 'ricos-schema';
import 'wix-rich-content-editor-common';
import './icons/InsertPluginIcon.js';
import './modals/SettingsModals.js';
import './components/modal-components/CollapsibleListSettings.js';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-plugin-commons';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginCollapsibleList = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: COLLAPSIBLE_LIST_TYPE,
    createPluginData: createCollapsibleListData,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(),
    toolbar: {
      getButtons: (config2, services) => getToolbarButtons(config2, services),
      isVisible: (selection) => {
        return !selection.node && !!findParentNodeClosestToPos(
          selection.$to,
          (node) => node.type.name === TIPTAP_COLLAPSIBLE_LIST_TYPE
        );
      }
    },
    shortcuts: [
      Shortcut({
        name: "MoveToNextElementTab",
        description: "ShortcutsSheet_CollapsibleList_MoveToNextElement",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Tab",
          windows: "Tab"
        },
        enabled: false,
        command: () => {
        }
      }),
      Shortcut({
        name: "MoveToNextElementEnter",
        description: "ShortcutsSheet_CollapsibleList_MoveToNextElement",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Enter",
          windows: "Enter"
        },
        enabled: false,
        command: () => {
        }
      }),
      Shortcut({
        name: "SelectEntireList",
        description: "ShortcutsSheet_CollapsibleList_SelectTheEntireList",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Meta+A",
          windows: "Ctrl+A"
        },
        enabled: false,
        command: () => {
        }
      })
    ]
  };
};

export { pluginCollapsibleList };
//# sourceMappingURL=editor.js.map
